import "jquery-ui/ui/widgets/autocomplete";
import {
  ACTUAL_FILTER,
  AUTOCOMPLETE_FIELD,
  JOB_TEXT,
  TOWN_TEXT,
  FUNCTION_TEXT,
  SEARCHER_TEXT,
  BASE_URL,
  CALL_GET_OFFERS,
  CALL_GET_FILTERS,
  CURRENT_REQUESTS,
  CALL_GET_SEO_PHRASE,
} from "./settings";
import { textNormalize } from "../../helpers";
import { hideOffersListLoader, showOffersListLoader } from "../../components/loader";
import { catchError } from "../../catchErrors";
import { initLastOffersViewedComp } from "../../components/lastOffersViewed";

$(() => {
  const goTopButton: JQuery<HTMLElement> = $("#goTopButton");
  goTopButton.css("display", "none");

  window.onscroll = () => {
    if (
      document.body.scrollTop > 260 ||
      document.documentElement.scrollTop > 260
    ) {
      goTopButton.css("display", "flex");
    } else {
      goTopButton.css("display", "none");
    }
  };

  goTopButton.on("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  $(document).on("click", "#filterButton", () => openFilters());

  $(document).on("click", "#provinceButton", () => {
    $("#offers").addClass("psf-offers--provinces");
    openFilters();
  });

  $(document).on("click", "#applyOfferFilters", () => generateURL());

  $(document).on("click", "#closeFilters", () => {
    $("#create-alert-button-wrapper").removeAttr('style');
    $("#offers").removeClass("psf-offers--open-filter");
    $("#offers").removeClass("psf-offers--provinces");
  });

  $(document).on("submit", "#offersSearcher", (event) => {
    ACTUAL_FILTER.search = $("#offersSearcherInput").val()?.toString() ?? "";
    ACTUAL_FILTER.autoCompletedSearch = "";
    generateURL();
    event.preventDefault();
  });

  $("#offersSearcherInput").autocomplete({
    source: (request: any, response: any) => {
      response(
        $.grep(AUTOCOMPLETE_FIELD, (value: string) => {
          const matcher = new RegExp(
            $.ui.autocomplete.escapeRegex(request.term),
            "i"
          );
          return matcher.test(value) || matcher.test(textNormalize(value));
        })
      );
    },
    minLength: 3,
    autoFocus: true,
    select: (event, ui) => {
      ACTUAL_FILTER.autoCompletedSearch = ui.item.label;
      ACTUAL_FILTER.search = "";
      generateURL();
    },
    classes: {
      "ui-autocomplete": "autocomplete-container",
    },
    position: {
      my: "left top", 
      at: "left-29 bottom+10"
    }
  });

  $("#offersSearcherInput").on("keyup", function (ev) {
    if (ev.key === "Enter")
      window.dataLayer.push({ event: "Busqueda_oferta_desde_buscador_enter" });
  });

  $(window).bind("popstate", function() {
    window.location.href = location.href
  });

  $(document).on("click", ".seo-text-block__title", (event) => {
    $(event.currentTarget).parent().toggleClass("seo-text-block--open");
  });
});

function openFilters(): void {
  $("#create-alert-button-wrapper").attr('style','display:none !important');
  $("#offers").addClass("psf-offers--open-filter");
}

//TODO passar a URLGenerator
function filteredText(text: string) {
  let regexAlphaNumeric = new RegExp(/[^a-z0-9]/g);
  let regexMultipleSpaces = new RegExp(/[ ]{1,}/g);

  return text
    .toLowerCase()
    .trim()
    .replace("(H/M)", "")
    .replace("(H)", "")
    .replace("(M)", "")
    .replace("(H/D)", "")
    .replace("(D)", "")
    .replace("(M/F)", "")
    .replace("(F)", "")
    .replace(regexMultipleSpaces, "-")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(regexAlphaNumeric, "-");
}

export function createURL(): string {
  const parameters: { key: string; value: string }[] = [];

  let onlyCulture = "";
  let routeParams = `/${JOB_TEXT}`;

  onlyCulture = `${BASE_URL}`;

  if (ACTUAL_FILTER.autoCompletedSearch !== "") {
    routeParams += `/${FUNCTION_TEXT}-${filteredText(
      ACTUAL_FILTER.autoCompletedSearch
    )}`;
  } else if (ACTUAL_FILTER.search !== "") {
    parameters.push({
      key: "search",
      value: encodeURIComponent(ACTUAL_FILTER.search),
    });
  } else {
    // Clean search input
    $("#offersSearcherInput").val('');
  }

  if (ACTUAL_FILTER.selectedTowns.length === 1) {
    routeParams += `/${TOWN_TEXT}-${filteredText(
      ACTUAL_FILTER.selectedTowns[0]
    )}/${filteredText(ACTUAL_FILTER.selectedProvince)}`;
  } else if (
    ACTUAL_FILTER.selectedProvince != null &&
    ACTUAL_FILTER.selectedProvince != ""
  ) {
    routeParams += `/${filteredText(ACTUAL_FILTER.selectedProvince)}`;

    ACTUAL_FILTER.selectedTowns.forEach((town: any) => {
      parameters.push({
        key: "towns",
        value: filteredText(town),
      });
    });
  } else {
    if (routeParams === `/${JOB_TEXT}`) {
      routeParams = `/${SEARCHER_TEXT}`;
    }

    if (
      ACTUAL_FILTER.selectedProvince != null &&
      ACTUAL_FILTER.selectedProvince != ""
    ) {
      parameters.push({
        key: "provinces",
        value: filteredText(ACTUAL_FILTER.selectedProvince),
      });
    }

    ACTUAL_FILTER.selectedTowns.forEach((town: any) => {
      parameters.push({
        key: "towns",
        value: filteredText(town),
      });
    });
  }

  if (ACTUAL_FILTER.minPublicationDate != null) {
    parameters.push({
      key: "minPublicationDate",
      value: ACTUAL_FILTER.minPublicationDate.toString(),
    });
  }

  if (ACTUAL_FILTER.type != null) {
    parameters.push({
      key: "type",
      value: ACTUAL_FILTER.type.toString(),
    });
  }

  if (ACTUAL_FILTER.workingDayType != null) {
    parameters.push({
      key: "workingDayType",
      value: ACTUAL_FILTER.workingDayType.toString(),
    });
  }

  if (ACTUAL_FILTER.isTeleworking != null) {
    parameters.push({
      key: "isTeleworking",
      value: ACTUAL_FILTER.isTeleworking.toString(),
    });
  }

  if (ACTUAL_FILTER.isInexperienced != null) {
    parameters.push({
      key: "isInexperienced",
      value: ACTUAL_FILTER.isInexperienced.toString(),
    });
  }

  if (ACTUAL_FILTER.isUntrained != null) {
    parameters.push({
      key: "isUntrained",
      value: ACTUAL_FILTER.isUntrained.toString(),
    });
  }

  if (ACTUAL_FILTER.isVehicleNeeded != null) {
    parameters.push({
      key: "isVehicleNeeded",
      value: ACTUAL_FILTER.isVehicleNeeded.toString(),
    });
  }

  let queryString: string = "";
  parameters.forEach(
    (parameter: { key: string; value: string }, index: number) => {
      if (index === 0) {
        queryString += `?${parameter.key}=${parameter.value}`;
      } else {
        queryString += `&${parameter.key}=${parameter.value}`;
      }
    }
  );
  return onlyCulture + routeParams + queryString;
}
// Generate the url of the filter
export function generateURL(): void {
  const generatedURL: string = createURL();
  CURRENT_REQUESTS.requestsNumber += 1;
  const currentRequest = CURRENT_REQUESTS.requestsNumber;
  const offersRequest = $.post({
    url: CALL_GET_OFFERS,
    data: { 
      page: 1, 
      filterViewModel: ACTUAL_FILTER,
      generatedURL
    }
  });
  const filtersRequest = $.post({
    url: CALL_GET_FILTERS,
    data: { filter: ACTUAL_FILTER }
  });
  const seoRequest = $.post({
    url: CALL_GET_SEO_PHRASE,
    data: { filter: ACTUAL_FILTER }
  });
  showOffersListLoader();
  if(window.innerWidth <= 767) $("#offers").removeClass('psf-offers--open-filter');
  $.when(offersRequest, filtersRequest, seoRequest)
  .done((dataOffers, dataFilters, dataSEO) => {
    const hasNewRequest: boolean = currentRequest < CURRENT_REQUESTS.requestsNumber;
    if(!hasNewRequest) {
      $('.psf-offers__header').remove();
      $('.psf-offers__chips').remove();
      $('.psf-seo-phrase-create-alert-panel').remove();
      $("#offers-list").replaceWith(dataOffers[0]).show("fast");
      $("#offersFilters").replaceWith(dataFilters[0]).show("fast");
      hideOffersListLoader();
      initLastOffersViewedComp();

      $("#seoPhrase").replaceWith(dataSEO[0]);
    }
    const pageRegex = "page=d+";
    if (generatedURL.includes(pageRegex)) generatedURL.replace(pageRegex, "");
    window.history.pushState({}, document.title, generatedURL);
  })
  .catch((error) => {
    CURRENT_REQUESTS.requestsNumber = 0;
    hideOffersListLoader();
    catchError(error);
  });
}

export function showMobileFilterButton(): void {
  $(".btn-filter-container").show();
}
